import ashleyDiGiacomoImage from 'assets/images/leadership_team/ashley_diGiacomo.png';
import brianConnollyImage from 'assets/images/leadership_team/brian_connolly.png';
import davidArklessImage from 'assets/images/leadership_team/david_arkless.png';
import derekBradyImage from 'assets/images/leadership_team/derek_brady.png';
import jackPonteImage from 'assets/images/leadership_team/jack_ponte.png';
import janinaCambriceImage from 'assets/images/leadership_team/janina_cambrice.png';
import jonPurizhanskyImage from 'assets/images/leadership_team/jon_purizhansky.png';
import markReimannImage from 'assets/images/leadership_team/mark_reimann.png';
import markTowerImage from 'assets/images/leadership_team/mark_tower.png';
import simranMalhotraImage from 'assets/images/leadership_team/simran_malhotra.png';
import tracieTerrillImage from 'assets/images/leadership_team/tracie_terrill.png';
import yanaGajimImage from 'assets/images/leadership_team/yana_gajim.png';

const config = [
  {
    name: 'Jon Purizhansky',
    title: 'Founder & Chief Executive Officer',
    bio: 'Founder of Joblio and a New York lawyer with years of international experience focused on leveraging technology to bring transparency and efficiency into otherwise non-transparent global ecosystems.',
    image: jonPurizhanskyImage
  },
  {
    name: 'David Arkless',
    title:
      'Non-Executive Chairman of the Advisory Board, Former Global President of the Manpower Group',
    bio: 'Experienced Founder with a demonstrated history of working in consulting and the staffing/recruitment industry. Former President at ManpowerGroup. Advisory Board Member UNHCR. Advisory Board Member IOM.',
    image: davidArklessImage
  },
  {
    name: 'Mark Tower',
    title: 'Chief Operating Officer',
    bio: 'Mark has been a leader in the human capital management industry for more than two decades. Mark is an MBA Graduate. Mark is inspired and motivated by his family which includes his wife Joanne, his two children and soon to be grandchild.',
    image: markTowerImage
  },
  {
    name: 'Mark Reimann',
    title: 'VP of Government Affairs & US Country Manager',
    bio: 'Mark Reimann is a highly decorated former Special Agent with the United States Department of Homeland Security who brings nearly 30 years of extensive experience in the field of immigration, human smuggling detection, human trafficking, and predatory labor fraud. A leading investigator in cases involving terrorism, narcotics, money laundering, and other transnational activity, Mr. Reimann has earned top awards from non-government organizations as well as from multiple federal agencies within the Department of Homeland Security and Department of Justice.',
    image: markReimannImage
  },
  {
    name: 'Yana Gajim',
    title: 'VP of Talent Acquisition & Global Director of the ACE Program',
    bio: 'Yana is an entrepreneur, lawyer and a dedicated human rights activist. She is currently the VP of Talent Acquisition and Global Director of the ACE Program at JOBLIO, INC.',
    image: yanaGajimImage
  },
  {
    name: 'Simran Malhotra',
    title: 'Recruitment Staffing Manager',
    bio: 'Simran has years of experience in high-volume recruitment, and administrative expertise in HR database management and employee onboarding. She is well-versed in employment legislation and has supported various industries like including hospitality, automotive, construction, manufacturing, retail, healthcare, and industrial.',
    image: simranMalhotraImage
  },
  {
    name: 'Janina Cambrice',
    title: 'Business Development, Atlanta, GA',
    bio: 'Janina is a leader in the staffing industry, where she spent the last 10 years expanding and growing companies successfully. Her areas of expertise include; Revenue Growth, Sales and Operations Leadership, Market Penetration, Candidate Pipeline Management and Employee Development. Creative and results oriented professional, recognized for stable sales ability, creating a growth driven work environment and transforming customer relationships into partnership alliances.',
    image: janinaCambriceImage
  },
  {
    name: 'Ashley DiGiacomo',
    title: 'Business Development, Buffalo, NY',
    bio: 'Experienced client development and recruiting expert, focusing on developing and implementing cutting-edge recruiting strategies, attracting high-caliber talent, and fostering robust client partnerships. With a track record of designing effective recruiting processes and ensuring smooth new hire integration, Ashley brings a comprehensive skill set to her work. Ashley’s career is marked by a strong client-centric approach, driving growth and surpassing organizational goals through strategic client development and talent acquisition.',
    image: ashleyDiGiacomoImage
  }
];

export default config;
